import React, { useState } from "react";
import { Box, Typography, Skeleton } from "@mui/material";
import images from "../../../assets/images";
import { BigModalOnboarding } from "../big-modal-onboarding/big-modal-onboarding";
import useUserStore from "../../../stores/userStore";
import { motion } from "framer-motion";

interface WelcomeOnboardingProps {
  onGetStarted: () => void;
  handleSkip: () => void;
}
const MotionBox = motion(Box);

export const WelcomeOnboarding = ({
  onGetStarted,
  handleSkip,
}: WelcomeOnboardingProps) => {
  const { user } = useUserStore();
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <Box
      sx={{
        position: "relative",
        height: "100dvh",
        background: "#0B0E1D",
        overflowX: "hidden",
        overflowY: "hidden",
        display: "flex",
        flexDirection: {
          xs: "column-reverse",
          sm: "column-reverse",
          md: "row",
        },
        justifyContent: "space-between",
        width: "100%",
        alignItems: "center",
      }}
    >
      <BigModalOnboarding
        title="Welcome to Your"
        subTitle="Learning Journey"
        description="I’m your AI-powered learning companion, here to support your professional growth."
        buttonText="Get Started!"
        handleNextPage={onGetStarted}
        handleSkip={handleSkip}
      />
      <Box
        sx={{
          position: "relative",
          width: { xs: "100%", sm: "100%", md: "50%" },
          height: { xs: "50%", sm: "50%", md: "100%" },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: { xs: 50, sm: 10, md: 210 },
            left: { xs: -16, sm: 0, md: -55 },
            zIndex: 5,
          }}
        >
          <MotionBox
            sx={{
              position: "relative",
              display: "inline-block",
              minHeight: "40px",
              p: "16px 24px",
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow:
                "0px 2px 4px rgba(0,0,0,0.3), 0px 4px 8px rgba(0,0,0,0.3), 0px 8px 16px rgba(0,0,0,0.3)",
              transition: "box-shadow 0.3s ease-in-out",
            }}
            whileHover={{
              boxShadow:
                "0px 4px 8px rgba(255,255,255,0.3), 0px 8px 16px rgba(255,255,255,0.3), 0px 16px 32px rgba(255,255,255,0.25)",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "10px", sm: "12px", md: "18px" },
                fontWeight: 700,
                color: "#103465",
              }}
            >
              Hi, {user.first_name}!
              <br /> I’m Coachmate
            </Typography>
          </MotionBox>
        </Box>
        {!imgLoaded && (
          <Skeleton
            variant="rectangular"
            animation="wave"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 1,
            }}
          />
        )}

        {/* Зображення */}
        <Box
          component="img"
          loading="eager"
          src={images.OnboardingBot}
          onLoad={() => setImgLoaded(true)}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: imgLoaded ? "block" : "none",
            zIndex: 0,
          }}
        />

        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: "none",
            zIndex: 2,
            background: {
              xs: `linear-gradient(
                to top,
                rgba(11, 14, 29, 1) 0%,
                rgba(11, 14, 29, 0) 40%
              )`,
              sm: `linear-gradient(
                to top,
                rgba(11, 14, 29, 1) 0%,
                rgba(11, 14, 29, 0) 40%
              )`,
              md: `linear-gradient(
                to right,
                rgba(11, 14, 29, 1) 0%,
                rgba(11, 14, 29, 0) 40%
              )`,
            },
          }}
        />
      </Box>
    </Box>
  );
};
